/* eslint-disable semi-spacing */
/* eslint-disable arrow-body-style */

interface IConfig {
  needCrossOrigin?: boolean;
}

function getLoadKey(obj: Record<string, string>, width: number, height: number, radius: number, keys: string[], themeValue: string, isCountryBar: boolean, config: IConfig) {
  const a = [];
  for (let i = 0; i < keys?.length; i++) {
    loadImg(obj[keys[i]], width, height, radius, keys[i], themeValue, isCountryBar, config);
    a.push(loadImg(obj[keys[i]], width, height, radius, keys[i], themeValue, isCountryBar, config));
  }
  return a;
}

const canvasOption = async (obj: Record<string, string>, width: number, height: number, radius: number, themeValue: string, isCountryBar: boolean, config: IConfig) => {
  const resOption = {};
  const keys = Object.keys(obj);

  const res = await Promise.allSettled(
    getLoadKey(obj, width, height, radius, keys, themeValue, isCountryBar, config),
  );
  res?.forEach((item, idx) => {
    // @ts-ignore
    resOption[keys[idx]] = item.value;
  });
  return resOption;
};

const loadImg = (url: string, width: number, height: number, radius: number, key: string, themeValue: string, isCountryBar: boolean, config: IConfig) => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    canvas.id = key;
    const widthTemp = isCountryBar ? width : width * 10;
    const heightTemp = isCountryBar ? height : height * 10;
    canvas.width = widthTemp;
    canvas.height = heightTemp;
    canvas.style.zIndex = '8';
    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;

    /**
     * 使用 css 样式处理将图片反色重置，抵消暗色模式时 body 反色导致图片的反色失真
     * canvas 反色调用的 getImageData 无法处理跨域图片，需要指定 img.crossOrigin 跨域策略，不加载跨域图片。会导致某些图片无法加载并抛错
     * 使用 css filter: 'invert(100%)' 将渲染图片的 canvas 反色重置
     */
    if (themeValue === 'Dark') {
      ctx.filter = 'invert(100%)';
    }

    const img = new Image();
    // 根据参数决定是否设置 crossOrigin，用于导出 canvas 或读取像素数据时防止跨域问题
    if (config?.needCrossOrigin) {
      img.crossOrigin = 'anonymous';
    }
    img.src = url;

    img.onload = () => {
      // 非国家图片才需要加圆角
      if (!isCountryBar) {
        ctx.save();
        roundedImage(ctx, 0, 0, widthTemp, heightTemp, radius * 10);
        ctx.clip();
      }
      ctx.drawImage(img, 0, 0, widthTemp, heightTemp);
      ctx.restore();
      resolve(canvas);
    };

    img.onerror = () => {
      reject('img error');
    };
    // 错误捕获，避免图片加载错误时（原有反色处理时的跨域问题）：Uncaught (in promise) img error
  }).catch((e) => {
    console.error('loadImg: ', e);
  });
};

const roundedImage = (ctx: CanvasRenderingContext2D, x: number, y: number, width: number, height: number, radius: number) => {
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.lineTo(x + width - radius, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
  ctx.lineTo(x + width, y + height - radius);
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
  ctx.lineTo(x + radius, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
  ctx.lineTo(x, y + radius);
  ctx.quadraticCurveTo(x, y, x + radius, y);
  ctx.closePath();
};

export { canvasOption };
